import { render, staticRenderFns } from "./HasParentAsset.vue?vue&type=template&id=6f213452&"
import script from "./HasParentAsset.vue?vue&type=script&lang=js&"
export * from "./HasParentAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports